export class Answer {
  public answerText: string;

  constructor(answerText: string) {
    this.answerText = answerText;
  }
}



// WEBPACK FOOTER //
// C:/work/new2/internal-frontend/src/app/models/answer.model.ts